"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pivotTableAdditionalFactories = exports.factoryNotationForAllMeasureColumnWidthItem = exports.factoryNotationForWeakMeasureColumnWidthItem = exports.factoryNotationForAttributeColumnLocator = exports.factoryNotationForMeasureColumnWidthItem = exports.factoryNotationForAttributeColumnWidthItem = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var isString_1 = tslib_1.__importDefault(require("lodash/isString"));
var partition_1 = tslib_1.__importDefault(require("lodash/partition"));
var sdk_ui_pivot_1 = require("@gooddata/sdk-ui-pivot");
function factoryNotationForAttributeColumnWidthItem(obj) {
    var _a = obj.attributeColumnWidthItem, attributeIdentifier = _a.attributeIdentifier, width = _a.width;
    var widthValue = width.value, allowGrowToFit = width.allowGrowToFit;
    // cannot use lodash compact, that would remove 0 values which we want to keep here
    var params = ["\"" + attributeIdentifier + "\"", "" + widthValue, allowGrowToFit && "true"].filter(function (item) { return !isNil_1.default(item); });
    return "newWidthForAttributeColumn(" + params.join(", ") + ")";
}
exports.factoryNotationForAttributeColumnWidthItem = factoryNotationForAttributeColumnWidthItem;
function factoryNotationForMeasureColumnWidthItem(obj) {
    var _a = obj.measureColumnWidthItem, locators = _a.locators, width = _a.width;
    // we know there is exactly one measureLocator and several attributeLocators
    var _b = partition_1.default(locators, sdk_ui_pivot_1.isMeasureColumnLocator), measureLocator = _b[0][0], attributeLocators = _b[1];
    var allowGrowToFit = isString_1.default(width) ? false : width.allowGrowToFit;
    var attributeLocatorFactories = attributeLocators.map(function (locator) {
        return factoryNotationForAttributeColumnLocator(locator);
    });
    // cannot use lodash compact, that would remove 0 values which we want to keep here
    var params = [
        "\"" + measureLocator.measureLocatorItem.measureIdentifier + "\"",
        "[" + attributeLocatorFactories.join(", ") + "]",
        isString_1.default(width.value) ? "\"" + width.value + "\"" : width.value,
        allowGrowToFit && "true",
    ].filter(function (item) { return !isNil_1.default(item); });
    return "newWidthForSelectedColumns(" + params.join(", ") + ")";
}
exports.factoryNotationForMeasureColumnWidthItem = factoryNotationForMeasureColumnWidthItem;
function factoryNotationForAttributeColumnLocator(obj) {
    var _a = obj.attributeLocatorItem, attributeIdentifier = _a.attributeIdentifier, element = _a.element;
    // cannot use lodash compact, that would remove 0 values which we want to keep here
    var params = ["\"" + attributeIdentifier + "\"", element && "\"" + element + "\""].filter(function (item) { return !isNil_1.default(item); });
    return "newAttributeColumnLocator(" + params.join(", ") + ")";
}
exports.factoryNotationForAttributeColumnLocator = factoryNotationForAttributeColumnLocator;
function factoryNotationForWeakMeasureColumnWidthItem(obj) {
    var _a = obj.measureColumnWidthItem, locator = _a.locator, width = _a.width;
    // cannot use lodash compact, that would remove 0 values which we want to keep here
    var params = [
        "\"" + locator.measureLocatorItem.measureIdentifier + "\"",
        width.value,
        width.allowGrowToFit && "true",
    ].filter(function (item) { return !isNil_1.default(item); });
    return "newWidthForAllColumnsForMeasure(" + params.join(", ") + ")";
}
exports.factoryNotationForWeakMeasureColumnWidthItem = factoryNotationForWeakMeasureColumnWidthItem;
function factoryNotationForAllMeasureColumnWidthItem(obj) {
    var _a = obj.measureColumnWidthItem.width, value = _a.value, allowGrowToFit = _a.allowGrowToFit;
    // cannot use lodash compact, that would remove 0 values which we want to keep here
    var params = [value, allowGrowToFit && "true"].filter(function (item) { return !isNil_1.default(item); });
    return "newWidthForAllMeasureColumns(" + params.join(", ") + ")";
}
exports.factoryNotationForAllMeasureColumnWidthItem = factoryNotationForAllMeasureColumnWidthItem;
exports.pivotTableAdditionalFactories = [
    {
        importInfo: {
            name: "newWidthForAttributeColumn",
            package: "@gooddata/sdk-ui-pivot",
            importType: "named",
        },
        transformation: function (obj) {
            return sdk_ui_pivot_1.isAttributeColumnWidthItem(obj)
                ? factoryNotationForAttributeColumnWidthItem(obj)
                : undefined;
        },
    },
    {
        importInfo: {
            name: "newAttributeColumnLocator",
            package: "@gooddata/sdk-ui-pivot",
            importType: "named",
        },
        transformation: function (obj) {
            return sdk_ui_pivot_1.isAttributeColumnLocator(obj) ? factoryNotationForAttributeColumnLocator(obj) : undefined;
        },
    },
    {
        importInfo: {
            name: "newWidthForAllColumnsForMeasure",
            package: "@gooddata/sdk-ui-pivot",
            importType: "named",
        },
        transformation: function (obj) {
            return sdk_ui_pivot_1.isWeakMeasureColumnWidthItem(obj)
                ? factoryNotationForWeakMeasureColumnWidthItem(obj)
                : undefined;
        },
    },
    {
        importInfo: {
            name: "newWidthForSelectedColumns",
            package: "@gooddata/sdk-ui-pivot",
            importType: "named",
        },
        transformation: function (obj) {
            return sdk_ui_pivot_1.isMeasureColumnWidthItem(obj) ? factoryNotationForMeasureColumnWidthItem(obj) : undefined;
        },
    },
    {
        importInfo: {
            name: "newWidthForAllMeasureColumns",
            package: "@gooddata/sdk-ui-pivot",
            importType: "named",
        },
        transformation: function (obj) {
            return sdk_ui_pivot_1.isAllMeasureColumnWidthItem(obj)
                ? factoryNotationForAllMeasureColumnWidthItem(obj)
                : undefined;
        },
    },
];
//# sourceMappingURL=pivotTableAdditionalFactories.js.map